export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-O-front-side-WEB-Large-5e05624b7d89766307111573312f79d1.jpg";